import { SpecificationConfigurationItem, SpecificationsLibrary } from '@grandvisionhq/fun-products'

export const sunglassesSpecifications: SpecificationConfigurationItem[] = [
  SpecificationsLibrary.brand,
  SpecificationsLibrary.frameColor,
  SpecificationsLibrary.lensColor,
  SpecificationsLibrary.frameShape,
  SpecificationsLibrary.frameMaterial,
  SpecificationsLibrary.gender,
  SpecificationsLibrary.polarized,
  SpecificationsLibrary.roadworthiness,
]
